module.exports = __webpack_public_path__ + "img/lineup18@2x.e9f96d3b.png";